import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import logodark from "../karuncup-dark-1.svg";

export default function PaymentResult() {
  const navigate = useNavigate();
  const location = useLocation();
  const [status, setStatus] = useState(false);
  const [transId, setTransId] = useState("");
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const statusParam = params.get("status");
    const transParam = params.get("transid");

    setStatus(statusParam === "1");
    setTransId(transParam || "");

    // Trigger fade-in animation
    setTimeout(() => setLoaded(true), 50);

    // Redirect after 3 seconds
    const timer = setTimeout(() => {
      navigate("../Profile");
    }, 3000);

    return () => clearTimeout(timer);
  }, [location.search, navigate]);

  return (
    <div className="min-h-screen bg-gray-900 flex flex-col items-center justify-center p-4">
      <img src={logodark} alt="Logo" className="h-16 w-auto mb-8" />

      <div
        className={`max-w-md w-full bg-gray-800 rounded-2xl shadow-lg p-6 text-center transform transition-all duration-500 ${
          loaded ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
        }`}
      >
        {status ? (
          <div className="flex flex-col items-center space-y-4">
            <span className="text-green-400 text-6xl">✔</span>
            <h2 className="text-2xl font-semibold text-white">پرداخت موفق بود!</h2>
            <p className="text-gray-400">شناسه تراکنش: {transId}</p>
          </div>
        ) : (
          <div className="flex flex-col items-center space-y-4">
            <span className="text-red-400 text-6xl">✖</span>
            <h2 className="text-2xl font-semibold text-white">پرداخت ناموفق بود.</h2>
            <p className="text-gray-400">لطفاً دوباره تلاش کنید.</p>
          </div>
        )}
      </div>

      <p className="mt-6 text-gray-500">
        در حال انتقال به پروفایل...
      </p>
    </div>
  );
}